export function initLandingFaq() {
    const roots = document.querySelectorAll('[data-landing-faq]');
    if (!roots.length) return;

    roots.forEach((root) => {
        const triggers = Array.from(root.querySelectorAll('[data-landing-faq-trigger]'));
        const answerAnimMs = 280;
        const panelToTrigger = new Map();

        triggers.forEach((trigger) => {
            const item = trigger.closest('.landing-faq__item');
            const panel = item?.querySelector('[data-landing-faq-panel]');
            if (panel) {
                panelToTrigger.set(panel, trigger);
            }
        });

        const closePanel = (panel) => {
            const trigger = panelToTrigger.get(panel);
            if (!trigger) return;

            if (panel.dataset.answerTimer) {
                window.clearTimeout(Number(panel.dataset.answerTimer));
                delete panel.dataset.answerTimer;
            }

            trigger.setAttribute('aria-expanded', 'false');
            panel.style.maxHeight = `${panel.scrollHeight}px`;
            panel.classList.remove('is-open');

            window.requestAnimationFrame(() => {
                panel.style.maxHeight = '0px';
            });

            const timer = window.setTimeout(() => {
                panel.hidden = true;
                delete panel.dataset.answerTimer;
            }, answerAnimMs);

            panel.dataset.answerTimer = String(timer);
        };

        const openPanel = (panel) => {
            const trigger = panelToTrigger.get(panel);
            if (!trigger) return;

            if (panel.dataset.answerTimer) {
                window.clearTimeout(Number(panel.dataset.answerTimer));
                delete panel.dataset.answerTimer;
            }

            trigger.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
            panel.classList.add('is-open');
            panel.style.maxHeight = '0px';

            window.requestAnimationFrame(() => {
                panel.style.maxHeight = `${panel.scrollHeight}px`;
            });

            window.setTimeout(() => {
                if (trigger.getAttribute('aria-expanded') === 'true') {
                    panel.style.maxHeight = 'none';
                }
            }, answerAnimMs);
        };

        triggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                const expanded = trigger.getAttribute('aria-expanded') === 'true';
                const item = trigger.closest('.landing-faq__item');
                const panel = item?.querySelector('[data-landing-faq-panel]');
                if (!panel) return;

                if (expanded) {
                    closePanel(panel);
                    return;
                }

                // Keep accordion exclusive: close any open panel first.
                panelToTrigger.forEach((_ownerTrigger, candidatePanel) => {
                    if (candidatePanel !== panel && !candidatePanel.hidden) {
                        closePanel(candidatePanel);
                    }
                });

                openPanel(panel);
            });
        });
    });
}
